import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=29c00f32&scoped=true&"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedChangesModal.vue?vue&type=style&index=0&id=29c00f32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c00f32",
  null
  
)

export default component.exports